import Index from '@/pages/audio/Index'

export default {
  path: 'audio/index',
  component: Index
}